import { Check, ChevronLeft } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const BookingStepper = ({ activeStep, steps, onBack, hideBackButton }) => {
  const { t } = useTranslation();
  
  // Calcular la posición de las líneas
  const getLinePosition = (index) => {
    const stepWidth = 100 / steps.length;
    const lineCenter = (index + 1) * stepWidth;
    // Centrar la línea de 30px en el punto medio
    return lineCenter - 1.25;
  };

  return (
    <div className="mb-5">
      {/* Stepper visual - Responsive */}
      <div className="mb-8">
        {/* Desktop stepper */}
        <div className="hidden md:flex justify-between items-center w-full relative overflow-hidden pt-1">
          {steps.map((step, index) => (
            <div key={step} className="flex items-center flex-1 min-w-0 justify-center">
              <div className="flex flex-col items-center gap-2">
                <div className={`flex items-center justify-center w-9 h-9 rounded-full font-semibold transition-all duration-300 flex-shrink-0 ${
                  index < activeStep 
                    ? 'bg-primary text-primary-dark' 
                    : index === activeStep 
                    ? 'bg-primary text-primary-dark shadow-primary-glow' 
                    : 'bg-gray-custom text-white'
                }`}>
                  {index < activeStep ? (
                    <Check size={20} />
                  ) : (
                    <span className="text-sm font-semibold">{index + 1}</span>
                  )}
                </div>
                <span className={`text-xs font-medium whitespace-nowrap transition-colors duration-300 overflow-hidden text-ellipsis max-w-[100px] text-center ${
                  index <= activeStep ? 'text-gray-light' : 'text-gray-light'
                }`}>
                  {step}
                </span>
              </div>
            </div>
          ))}
          
          {/* Líneas del stepper posicionadas absolutamente */}
          {steps.map((step, index) => (
            index < steps.length - 1 && (
              <div 
                key={`line-${index}`}
                className={`absolute top-[18px] w-[30px] h-0.5 transition-colors duration-300 flex-shrink-0 z-10 ${
                  index < activeStep ? 'bg-primary' : 'bg-gray-custom'
                }`}
                style={{
                  left: `${getLinePosition(index)}%`
                }}
              />
            )
          ))}
        </div>

        {/* Mobile stepper */}
        <div className="md:hidden bg-background rounded-xl mx-4 p-5 border border-primary mb-5">
          <div className="mb-3">
            <span className="block text-primary text-sm font-medium mb-2">
              Paso {activeStep + 1} de {steps.length}
            </span>
            <div className="w-full h-1.5 bg-gray-custom rounded-full overflow-hidden">
              <div 
                className="h-full bg-primary rounded-full transition-all duration-300"
                style={{ width: `${((activeStep + 1) / steps.length) * 100}%` }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Botón atrás (oculto cuando la reserva ya está confirmada) */}
      {activeStep > 0 && !hideBackButton && (
        <div className="flex justify-start">
          <button
            className="mx-4 px-6 py-3 border border-primary text-primary bg-transparent rounded-lg cursor-pointer transition-colors duration-300 hover:bg-primary hover:text-primary-dark flex items-center gap-2"
            onClick={onBack}
          >
            <ChevronLeft size={16} />
            {t('stepper.back')}
          </button>
        </div>
      )}
    </div>
  );
};

export default BookingStepper; 